import { useEffect } from 'react'
import { useLocale } from '../hooks/useLocale'

const SEO_CONTENT = {
  es: {
    title: 'Nucelar - Desarrollo y Consultoría de Software',
    description: 'Ayudamos a empresas a construir soluciones tecnológicas que marcan la diferencia. Desarrollo de software y consultoría técnica.',
  },
  en: {
    title: 'Nucelar - Software Development & Consulting',
    description: 'We help companies build technology solutions that make a difference. Software development and technical consulting.',
  },
}

export default function SEO() {
  const { locale } = useLocale()
  const content = SEO_CONTENT[locale]

  useEffect(() => {
    document.title = content.title
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]')
    if (!metaDescription) {
      metaDescription = document.createElement('meta')
      metaDescription.setAttribute('name', 'description')
      document.head.appendChild(metaDescription)
    }
    metaDescription.setAttribute('content', content.description)

    // Update lang attribute
    document.documentElement.lang = locale
  }, [locale, content])

  return null
}
